import Marquee from "react-fast-marquee";

const WORDS = [
  "The Voice of the Adolescent",
  "Educate",
  "Inspire",
  "Empower",
  "Celebrate",
];

export default function MissionMarquee() {
  return (
    <section
      data-testid="mission-marquee"
      className="relative border-y border-[#2E1A6B]/20 bg-[#F4F4F0] py-6 md:py-8 overflow-hidden"
      aria-label="Mission"
    >
      <Marquee gradient={false} speed={45} pauseOnHover>
        {WORDS.concat(WORDS).map((w, i) => (
          <span key={i} className="marquee-item font-display italic text-3xl md:text-5xl text-[#2E1A6B] leading-none">
            {w}
            <span className="inline-block h-2 w-2 bg-[#2AC1E0]" />
          </span>
        ))}
      </Marquee>
    </section>
  );
}
